<template>
	<mobile v-if="mobile"></mobile>
	<pc v-else></pc>
</template>

<script>
	import pc from './claim_list_pc.vue'
	import mobile from './claim_list_m.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'claim_list',
		
		components: {
			pc,
			mobile
		},
		
		computed: {
			...mapState(['mobile'])
		}
	};
</script>

<style lang="stylus" scoped>
</style>